import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import {
  CompanyChangeHoldingCompanyActionDictionary,
  CompanyChangeHoldingCompanyActionEnum
} from '../../asic-forms/company/company-change-holding-company/CompanyChangeHoldingCompanyActionEnum';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { CompanyChangeHoldingCompanyComponent } from '../../asic-forms/company/company-change-holding-company/company-change-holding-company.component';
import { CountriesService } from "../../../shared/services/countries.service";

export class CompanyChangeHoldingCompany extends EntityChangeData {
  static override readonly $type = 'CompanyChangeHoldingCompany';
  holdingCompanyName: string;
  holdingCompanyAcn: string;
  action: CompanyChangeHoldingCompanyActionEnum;
  holdingCompanyPlaceOfIncorporation: string;
  holdingCompanyAbn?: string;

  constructor(data: Partial<CompanyChangeHoldingCompany> = {}) {
    super(data);

    this.holdingCompanyName = data.holdingCompanyName ?? '';
    this.holdingCompanyAcn = data.holdingCompanyAcn ?? '';
    this.action = data.action ?? CompanyChangeHoldingCompanyActionEnum.AP;
    this.holdingCompanyPlaceOfIncorporation = data.holdingCompanyPlaceOfIncorporation ?? '';
    this.holdingCompanyAbn = data.holdingCompanyAbn;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();

    dict
      .addDate('Date of Change', this.changeDate)
      .add('Change Type', CompanyChangeHoldingCompanyActionDictionary[this.action.toString()])
      .add('Holding Company Name', this.holdingCompanyName);

    if (CountriesService.isAustralia(this.holdingCompanyPlaceOfIncorporation)) {
      dict.addAcn('Holding Company ACN', this.holdingCompanyAcn);
    } else if (this.holdingCompanyAbn) {
      dict.addAbn('Holding Company ABN', this.holdingCompanyAbn);
    }

    if (this.action !== CompanyChangeHoldingCompanyActionEnum.NO) {
      dict.addCountry('Place of Incorporation', this.holdingCompanyPlaceOfIncorporation);
    }

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as CompanyChangeHoldingCompanyComponent).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit = false): NgbModalRef {
    const instance = modalRef.componentInstance as CompanyChangeHoldingCompanyComponent;
    const uhcExist = company.ultimateHoldingCompany?.exists || company.ultimateHoldingCompany?.name;

    if (uhcExist) {
      this.holdingCompanyName = company.ultimateHoldingCompany?.name ?? '';
      this.holdingCompanyAcn = company.ultimateHoldingCompany?.acnOrArbn ?? '';
      this.holdingCompanyPlaceOfIncorporation = company.ultimateHoldingCompany?.jurisdiction ?? '';
      this.holdingCompanyAbn = company.ultimateHoldingCompany?.acnOrArbn ?? '';
    }

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = structuredClone(this);

    return modalRef;
  }
}
